import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createBlock as _createBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onDblclick"]
const _hoisted_2 = { style: {"display":"flex","flex-direction":"column","justify-content":"space-between","height":"100%"} }
const _hoisted_3 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Beschreibung")
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Beschreibung")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_snackbar = _resolveComponent("error-snackbar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_error_snackbar, {
      snackbar: _ctx.errorSnackbar,
      "onUpdate:snackbar": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.errorSnackbar) = $event))
    }, null, 8, ["snackbar"]),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "auto" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, { onClick: _ctx.openAddTemplateDialog }, {
                  default: _withCtx(() => [
                    _createTextVNode("Template hinzufügen")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  class: "ml-5",
                  onClick: _ctx.openAddCategorieDialog
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Kategorie hinzufügen")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  class: "ml-5",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSortingModal = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Kategorien sortieren")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  label: "Suche",
                  modelValue: _ctx.searchInput,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchInput) = $event)),
                  class: "search-input",
                  "single-line": "",
                  "hide-details": "",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCategories, (category) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: category.id
          }, [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "4",
                  lg: "3"
                }, {
                  default: _withCtx(() => [
                    (_ctx.editingField.type !== 'categoryName' || _ctx.editingField.id !== (category ? category.id : -1))
                      ? (_openBlock(), _createElementBlock("h2", {
                          key: 0,
                          onDblclick: ($event: any) => (_ctx.startEditingField('categoryName', category ? category.id : -1))
                        }, _toDisplayString(category ? category.name : ''), 41, _hoisted_1))
                      : (_openBlock(), _createBlock(_component_v_text_field, {
                          key: 1,
                          modelValue: _ctx.editedValue,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editedValue) = $event)),
                          "single-line": "",
                          onKeydown: [
                            _withKeys(($event: any) => (_ctx.updateField(category ? category.id : -1)), ["enter"]),
                            _withKeys(_ctx.cancelEditingField, ["esc"])
                          ],
                          onBlur: _ctx.cancelEditingField,
                          ref_for: true,
                          ref: "editField",
                          class: "mt-5 mr-5"
                        }, null, 8, ["modelValue", "onKeydown", "onBlur"]))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_draggable, {
                  modelValue: category.templates,
                  "onUpdate:modelValue": ($event: any) => ((category.templates) = $event),
                  group: { name: 'templates', pull: 'clone', put: false },
                  tag: "transition-group",
                  animation: 150,
                  onEnd: ($event: any) => (_ctx.saveTemplateSorting(category.templates))
                }, {
                  item: _withCtx(({ element }) => [
                    (_openBlock(), _createBlock(_component_v_col, {
                      key: element.id,
                      cols: "12",
                      sm: "6",
                      md: "4",
                      lg: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          onClick: ($event: any) => (_ctx.openDialog(element))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_v_btn, {
                                  class: "mr-2 mt-2",
                                  density: "comfortable",
                                  icon: "mdi-pencil",
                                  onClick: _withModifiers(($event: any) => (_ctx.openEditDialog(element)), ["stop"])
                                }, null, 8, ["onClick"])
                              ]),
                              _createVNode(_component_v_card_text, { class: "d-flex justify-center align-center mt-n4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "60" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString((element.icon).toLowerCase()), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_card_title, { class: "d-flex justify-center align-center" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(element.name), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_card_text, { class: "d-flex justify-center align-center" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(element.description), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onEnd"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_divider, { class: "border-opacity-50 mt-12 mb-12" })
          ], 64))
        }), 128)),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.dialog,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialog) = $event)),
          width: "1000"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedTemplate?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_form, { ref: "form" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateFields, (field, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (field.field_type === 'text')
                                      ? (_openBlock(), _createBlock(_component_v_text_field, {
                                          key: 0,
                                          label: field.field_label,
                                          hint: field.field_description,
                                          required: field.is_required,
                                          modelValue: _ctx.fieldValues[field.field_name],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.fieldValues[field.field_name]) = $event)
                                        }, null, 8, ["label", "hint", "required", "modelValue", "onUpdate:modelValue"]))
                                      : (field.field_type === 'textarea')
                                        ? (_openBlock(), _createBlock(_component_v_textarea, {
                                            key: 1,
                                            label: field.field_label,
                                            hint: field.field_description,
                                            required: field.is_required,
                                            modelValue: _ctx.fieldValues[field.field_name],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.fieldValues[field.field_name]) = $event),
                                            "auto-grow": ""
                                          }, null, 8, ["label", "hint", "required", "modelValue", "onUpdate:modelValue"]))
                                        : (field.field_type === 'date')
                                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                                              key: 2,
                                              onInput: (event) => _ctx.updateDateFieldValue(field.field_name, event.target.value),
                                              label: "Startdatum",
                                              type: "date",
                                              "return-mask": "dd.MM.yyyy"
                                            }, null, 8, ["onInput"]))
                                          : (field.field_type == 'select' && field.field_name.includes('salutation:'))
                                            ? (_openBlock(), _createBlock(_component_v_select, {
                                                key: 3,
                                                items: ['Sehr geehrter Herr', 'Sehr geehrte Frau', 'Sehr geehrter Mr.', 'Sehr geehrte Ms.'],
                                                modelValue: _ctx.fieldValues[field.field_name],
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.fieldValues[field.field_name]) = $event)
                                              }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                                            : (field.field_type == 'select' && field.field_name.includes('gender:'))
                                              ? (_openBlock(), _createBlock(_component_v_select, {
                                                  key: 4,
                                                  items: ['Herr', 'Frau', ,'Mr.', 'Mrs.', 'Hubschrauber', 'Lokomotive'],
                                                  modelValue: _ctx.fieldValues[field.field_name],
                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.fieldValues[field.field_name]) = $event)
                                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                                              : (_openBlock(), _createBlock(_component_v_text_field, {
                                                  key: 5,
                                                  label: field.field_label,
                                                  hint: field.field_description,
                                                  required: field.is_required,
                                                  modelValue: _ctx.fieldValues[field.field_name],
                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.fieldValues[field.field_name]) = $event)
                                                }, null, 8, ["label", "hint", "required", "modelValue", "onUpdate:modelValue"]))
                                  ], 64))
                                }), 128))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_textarea, {
                                  value: _ctx.renderTemplate(),
                                  rows: _ctx.calculateRows(),
                                  "no-resize": ""
                                }, null, 8, ["value", "rows"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      text: "true",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialog = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Schließen")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      text: "true",
                      onClick: _ctx.copyToClipboard
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Copy to Clipboard")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.showSortingModal,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showSortingModal) = $event)),
          "max-width": "600px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Kategorien sortieren ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_draggable, {
                      modelValue: _ctx.categories,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.categories) = $event)),
                      list: _ctx.categories,
                      tag: "transition-group",
                      animation: 150
                    }, {
                      item: _withCtx(({ element }) => [
                        (_openBlock(), _createBlock(_component_v_list_item, {
                          key: element.id,
                          class: "list-item mb-2 d-flex align-center",
                          style: {"cursor":"move"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_avatar, {
                              size: "24",
                              class: "me-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-drag-variant")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(element.name), 1)
                          ]),
                          _: 2
                        }, 1024))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "list"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "error",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showSortingModal = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Abbrechen")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, { onClick: _ctx.saveCategorySorting }, {
                      default: _withCtx(() => [
                        _createTextVNode("Speichern")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.addTemplateDialog,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.addTemplateDialog) = $event)),
          width: "1000"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Neue Vorlage hinzufügen")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_form, { ref: "addTemplateForm" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  label: "Kategorie",
                                  "item-value": "id",
                                  "item-title": "name",
                                  items: _ctx.categories,
                                  modelValue: _ctx.newTemplate.category_id,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newTemplate.category_id) = $event)),
                                  required: ""
                                }, null, 8, ["items", "modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  label: "Name",
                                  required: "",
                                  modelValue: _ctx.newTemplate.name,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newTemplate.name) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  label: "Beschreibung",
                                  required: "",
                                  modelValue: _ctx.newTemplate.description,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newTemplate.description) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  label: "Icon",
                                  required: "",
                                  readonly: "",
                                  modelValue: _ctx.selectedIcon.name,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedIcon.name) = $event)),
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.iconPickerDialog = true))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_dialog, {
                                  modelValue: _ctx.iconPickerDialog,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.iconPickerDialog) = $event)),
                                  "max-width": "600"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Icon Picker")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_text, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (iconItem, index) => {
                                                  return (_openBlock(), _createBlock(_component_v_col, {
                                                    key: index,
                                                    cols: "2",
                                                    onClick: ($event: any) => (_ctx.selectIcon(iconItem))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, {
                                                        mdi: iconItem.path
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(iconItem.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["mdi"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_actions, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_btn, {
                                              text: "true",
                                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.iconPickerDialog = false))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Schließen")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _createVNode(_component_v_textarea, {
                                  label: "Vorlagentext",
                                  required: "",
                                  modelValue: _ctx.newTemplate.text,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newTemplate.text) = $event)),
                                  class: "mt-4"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_table, null, {
                                  default: _withCtx(() => [
                                    _hoisted_4,
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFields, (field) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: field.id
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(field.field_name), 1),
                                          _createElementVNode("td", null, _toDisplayString(field.field_description), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      text: "true",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addTemplateDialog = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Abbrechen")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      text: "true",
                      onClick: _ctx.addNewTemplate
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Hinzufügen")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.addCategorieDialog,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.addCategorieDialog) = $event)),
          width: "500"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Neue Kategorie hinzufügen")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_form, { ref: "addCategorieForm" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  label: "Name",
                                  required: "",
                                  modelValue: _ctx.newCategorie.name,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newCategorie.name) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      text: "true",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.addCategorieDialog = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Abbrechen")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      text: "true",
                      onClick: _ctx.addNewCategorie
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Hinzufügen")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.editTemplateDialog,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.editTemplateDialog) = $event)),
          width: "1000"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Template bearbeiten")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_form, { ref: "editTemplateForm" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  label: "Kategorie",
                                  "item-value": "id",
                                  "item-title": "name",
                                  items: _ctx.categories,
                                  modelValue: _ctx.editedTemplate.category_id,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editedTemplate.category_id) = $event)),
                                  required: ""
                                }, null, 8, ["items", "modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  label: "Name",
                                  required: "",
                                  modelValue: _ctx.editedTemplate.name,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.editedTemplate.name) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  label: "Beschreibung",
                                  required: "",
                                  modelValue: _ctx.editedTemplate.description,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editedTemplate.description) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  label: "Icon",
                                  required: "",
                                  readonly: "",
                                  modelValue: _ctx.selectedIcon.name,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.selectedIcon.name) = $event)),
                                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.iconPickerDialog = true))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_dialog, {
                                  modelValue: _ctx.iconPickerDialog,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.iconPickerDialog) = $event)),
                                  "max-width": "600"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Icon Picker")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_text, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (iconItem, index) => {
                                                  return (_openBlock(), _createBlock(_component_v_col, {
                                                    key: index,
                                                    cols: "2",
                                                    onClick: ($event: any) => (_ctx.selectIcon(iconItem))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, {
                                                        mdi: iconItem.path
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(iconItem.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["mdi"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_actions, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_btn, {
                                              text: "true",
                                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.iconPickerDialog = false))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Schließen")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _createVNode(_component_v_textarea, {
                                  label: "Vorlagentext",
                                  required: "",
                                  modelValue: _ctx.editedTemplate.text,
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.editedTemplate.text) = $event)),
                                  class: "mt-4"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_table, null, {
                                  default: _withCtx(() => [
                                    _hoisted_5,
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFields, (field) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: field.id
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(field.field_name), 1),
                                          _createElementVNode("td", null, _toDisplayString(field.field_description), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      text: "true",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.editTemplateDialog = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Abbrechen")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      text: "true",
                      onClick: _ctx.editTemplate
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Speichern")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ], 64))
}